import React from 'react';
import RevitImg from "../assets/img/images/audodesk1.jpg";

function Autodesk() {
  return (
    <div style={styles.pageWrapper}>
      {/* Heading Section */}
      <div style={styles.headingBox}>
        <h1 style={styles.headingText}>Autodesk Revit</h1>
      </div>

      {/* Content Container */}
      <div style={styles.contentBox}>
        <p style={styles.paragraph}>
          <strong>Autodesk Revit</strong> is a Building Information Modeling (BIM) software that helps architects, engineers, and contractors design, simulate, and manage building projects. It's an industry standard for AEC (architecture, engineering, and construction) professionals.
        </p>

        {/* Features */}
        <h4 style={styles.sectionTitleYellow}>Features</h4>
        <ul style={styles.list}>
          <li>3D modeling: Design and visualize buildings in 3D</li>
          <li>Collaboration: Collaborate with other team members in real time</li>
          <li>Project management: Streamline project management with instant revisions to plans, schedules, and 3D visualizations</li>
          <li>Integration: Integrate project information like materials, dimensions, schedules, and costs directly into the model</li>
          <li>Automation: Use automation to optimize plans and fabrication</li>
        </ul>

        {/* Benefits + Image */}
        <div style={styles.flexSection}>
          <div style={styles.flexItem}>
            <h4 style={styles.sectionTitleYellow}>Benefits</h4>
            <ul style={styles.list}>
              <li>Improves work processes</li>
              <li>Streamlines modeling</li>
              <li>Enables collaboration between teams</li>
              <li>Reduces errors and inconsistencies in the design process</li>
              <li>Increases the productivity of structural engineers</li>
              <li>Significantly reduces mistakes in construction projects</li>
            </ul>

            {/* Who Uses Revit */}
            <h4 style={styles.sectionTitleYellow}>Who Uses Revit</h4>
            <p style={styles.paragraph}>
              Revit is used by architects, general contractors, sub-contractors, estimators, and fabricators. It's also used by structural engineers, mechanical, electrical, and plumbing (MEP) engineers.
            </p>

            {/* Use Cases */}
            <h4 style={styles.sectionTitleYellow}>Autodesk says you can use Revit to:</h4>
            <ul style={styles.list}>
              <li>Model shapes, structures, and systems in 3D</li>
              <li>Unite multidisciplinary project teams</li>
            </ul>
          </div>

          <div style={styles.flexItem}>
            <img src={RevitImg} alt="Revit Example" style={styles.image} />
          </div>
        </div>
      </div>
    </div>
  );
}

// Styles
const styles = {
  pageWrapper: {
    padding: '20px',
    backgroundColor: '#f9fafb',
    marginTop: '5rem',
    fontFamily: "'Poppins', sans-serif",
  },
  headingBox: {
    padding: '12px',
    borderRadius: '10px',
    textAlign: 'center',
    margin: '0 auto 30px',
    color: "#7620ff",
  },
  headingText: {
    fontWeight: 'bold',
  },
  contentBox: {
    padding: '0px 20px',
    borderRadius: '10px',
    maxWidth: '80%',
    margin: '0 auto',
  },
  paragraph: {
    color: '#333',
    lineHeight: '1.7',
    marginLeft:"20px"
  },
  sectionTitleYellow: {
    color: '#fdba00',
    marginTop: '20px',
  },
  flexSection: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    marginTop: '30px',
  },
  flexItem: {
    flex: '1 1 300px',
  },
  image: {
    width: '100%',
    borderRadius: '10px',
    objectFit: 'cover',
    height: 'auto',
  },
  list: {
    color: '#333',
    paddingLeft: '20px',
    marginTop: '10px',
    lineHeight: '1.7',
  },
};

export default Autodesk;
